import { Display } from "rot-js";
import { DisplayOptions } from "rot-js/lib/display/types";

export class RDisplay extends Display {
  constructor(opts: Partial<DisplayOptions> | undefined) {
    super(opts);
  }

  drawOver(
    x: number,
    y: number,
    ch: string | null,
    fg: string | null,
    bg: string | null
  ) {
    const key = `${x},${y}`;
    const existing = this._data[key];
    if (existing) {
      existing[2] = ch || existing[2];
      existing[3] = fg || existing[3];
      existing[4] = bg || existing[4];
    } else {
      this.draw(x, y, ch, fg, bg);
    }
  }

  drawAppend(
    x: number,
    y: number,
    ch: string,
    fg: string | null,
    bg: string | null
  ) {
    const key = `${x},${y}`;
    const existing = this._data[key];
    if (existing) {
      existing[2] = Array.isArray(existing[2])
        ? [...existing[2], ch]
        : [existing[2], ch];
      existing[3] = Array.isArray(existing[3])
        ? [...existing[3], fg]
        : [existing[3], fg];
      existing[4] = Array.isArray(existing[4])
        ? [...existing[4], bg]
        : [existing[4], bg];
    } else {
      this.draw(x, y, ch, fg, bg);
    }
  }

  drawOverFirst(
    x: number,
    y: number,
    ch: string | null,
    fg: string | null,
    bg: string | null
  ) {
    const key = `${x},${y}`;
    const existing = this._data[key];
    if (existing) {
      if (
        Array.isArray(existing[2]) &&
        Array.isArray(existing[3]) &&
        Array.isArray(existing[4])
      ) {
        existing[2][0] = ch || existing[2][0];
        existing[3][0] = fg || existing[3][0];
        existing[4][0] = fg || existing[4][0];
      } else {
        this.drawOver(x, y, ch, fg, bg);
      }
    } else {
      this.draw(x, y, ch || " ", fg, bg);
    }
  }
  drawOverLast(
    x: number,
    y: number,
    ch: string | null,
    fg: string | null,
    bg: string | null
  ) {
    const key = `${x},${y}`;
    const existing = this._data[key];
    if (existing) {
      if (
        Array.isArray(existing[2]) &&
        Array.isArray(existing[3]) &&
        Array.isArray(existing[4])
      ) {
        const idx = existing[2].length - 1;
        existing[2][idx] = ch || existing[2][idx];
        existing[3][idx] = fg || existing[3][idx];
        existing[4][idx] = bg || existing[4][idx];
      } else {
        this.drawOver(x, y, ch, fg, bg);
      }
    } else {
      this.draw(x, y, ch || " ", fg, bg);
    }
  }
}
